import { requestGet, requestPost } from '@/utils/request';

const api = {
	LIST: '/op/user_transfer_list',
	PAY: '/op/user_transfer_pay',
	REFUSE: '/op/user_transfer_refuse',
	MANUAL_NOTIFY: '/op/user_transfer_manual_notify',
};

export async function userTransferList(queryParams) {
	return requestGet(api.LIST, queryParams);
}

export async function userTransferPay(form) {
	return requestPost(api.PAY, form);
}

export async function userTransferRefuse(form) {
	return requestPost(api.REFUSE, form);
}

export async function userTransferManualNotify(form) {
	return requestPost(api.MANUAL_NOTIFY, form);
}
